document.addEventListener("DOMContentLoaded", function () {
  //Perfectly Working Code
  // const hardCoverCanvas = document.getElementById("hardCoverCanvas");
  // if (hardCoverCanvas) {
  //   hardCoverCanvas.style.display = "none"; // Always hide on fresh load
  // }
  // const { jsPDF } = window.jspdf;
  // const PX_TO_MM_300DPI = 25.4 / 300;

  // async function addCanvasToPDF(pdf, canvas, isFirstPage = false) {
  //   const widthMm = canvas.width * PX_TO_MM_300DPI;
  //   const heightMm = canvas.height * PX_TO_MM_300DPI;
  //   const imgData = canvas.toDataURL("image/jpeg", 1.0);

  //   if (!isFirstPage) {
  //     pdf.addPage([widthMm, heightMm], "portrait");
  //   } else {
  //     pdf.setPage(1);
  //     pdf.internal.pageSize.setWidth(widthMm);
  //     pdf.internal.pageSize.setHeight(heightMm);
  //   }

  //   pdf.addImage(imgData, "JPEG", 0, 0, widthMm, heightMm);
  // }

  // async function addImageToPDF(pdf, imgElement) {
  //   return new Promise((resolve) => {
  //     // Skip already added images
  //     if (imgElement.dataset.addedToPdf === "true") {
  //       return resolve();
  //     }

  //     const img = new Image();
  //     img.crossOrigin = "anonymous";
  //     img.onload = function () {
  //       const tempCanvas = document.createElement("canvas");
  //       const ctx = tempCanvas.getContext("2d");

  //       tempCanvas.width = img.naturalWidth;
  //       tempCanvas.height = img.naturalHeight;
  //       ctx.drawImage(img, 0, 0);

  //       const format = img.src.endsWith(".png") ? "PNG" : "JPEG";
  //       const imgData = tempCanvas.toDataURL(`image/${format.toLowerCase()}`);

  //       const widthMm = tempCanvas.width * PX_TO_MM_300DPI;
  //       const heightMm = tempCanvas.height * PX_TO_MM_300DPI;

  //       pdf.addPage([widthMm, heightMm], "portrait");
  //       pdf.addImage(imgData, "JPEG", 0, 0, widthMm, heightMm);

  //       // Mark this image as already added
  //       imgElement.dataset.addedToPdf = "true";
  //       resolve();
  //     };
  //     img.src = imgElement.src;
  //   });
  // }

  // async function getAccessTokenFromRefreshToken() {
  //   const clientId =
  //     "305823208931-5g0c1pm7c7sf57qhj3rk78db1ru37drq.apps.googleusercontent.com";
  //   const clientSecret = "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"; // ⚡ Put your client secret here
  //   const refreshToken =
  //     "1//04D_ILLYCJGumCgYIARAAGAQSNwF-L9Ir32TSQsrZJ3P0eXKz1JDRgU5GIGZzY4cCYXuGzC6GsXmJH2pxJF9ual3BCFqqaufwtWo"; // ⚡ Put your refresh token here

  //   const formBody = new URLSearchParams();
  //   formBody.append("client_id", clientId);
  //   formBody.append("client_secret", clientSecret);
  //   formBody.append("refresh_token", refreshToken);
  //   formBody.append("grant_type", "refresh_token");

  //   const response = await fetch("https://oauth2.googleapis.com/token", {
  //     method: "POST",
  //     headers: { "Content-Type": "application/x-www-form-urlencoded" },
  //     body: formBody,
  //   });

  //   const data = await response.json();
  //   if (data.access_token) {
  //     return data.access_token;
  //   } else {
  //     throw new Error("Failed to refresh access token");
  //   }
  // }

  // async function uploadToGoogleDrive(pdfBlob, accessToken) {
  //   return new Promise((resolve, reject) => {
  //     const fileMetadata = {
  //       name: `book-preview-${Date.now()}.pdf`,
  //       mimeType: "application/pdf",
  //     };

  //     const form = new FormData();
  //     form.append(
  //       "metadata",
  //       new Blob([JSON.stringify(fileMetadata)], { type: "application/json" })
  //     );
  //     form.append("file", pdfBlob);

  //     fetch(
  //       "https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart&fields=id,webViewLink",
  //       {
  //         method: "POST",
  //         headers: {
  //           Authorization: `Bearer ${accessToken}`,
  //         },
  //         body: form,
  //       }
  //     )
  //       .then((res) => res.json())
  //       .then((file) => {
  //         console.log("Google Drive File:", file);
  //         resolve(file.webViewLink);
  //       })
  //       .catch((error) => {
  //         console.error("Upload failed:", error);
  //         reject(error);
  //       });
  //   });
  // }

  //PerfectlY Working Code
  // const firebaseConfig = {
  //   apiKey: "AIzaSyC7SQV_ZXzGW283LvwCy4ri8T7ZDPCLtCw",
  //   authDomain: "laylbooks.firebaseapp.com",
  //   projectId: "laylbooks",
  //   storageBucket: "laylbooks.firebasestorage.app",
  //   messagingSenderId: "618712227972",
  //   appId: "1:618712227972:web:3f2d977c167133d158a2d1",
  //   measurementId: "G-S01MF49F84",
  // };
  // firebase.initializeApp(firebaseConfig);

  // let isExporting = false;
  // let isExportComplete = false;
  // let exportResult = null;

  // // Upload to Firebase Storage
  // async function uploadToFirebaseStorage(pdfBlob) {
  //   return new Promise((resolve, reject) => {
  //     const storageRef = firebase.storage().ref();
  //     const pdfRef = storageRef.child(`books/book-preview-${Date.now()}.pdf`);

  //     const uploadTask = pdfRef.put(pdfBlob);

  //     uploadTask.on(
  //       "state_changed",
  //       null,
  //       (error) => {
  //         console.error("Upload failed:", error);
  //         reject(error);
  //       },
  //       async () => {
  //         const downloadURL = await pdfRef.getDownloadURL();
  //         console.log("Firebase File URL:", downloadURL);
  //         resolve(downloadURL);
  //       }
  //     );
  //   });
  // }

  // async function generateCoverPdf(widthMm, heightMm, type = "standard") {
  //   const coverPdf = new jsPDF({
  //     orientation: "portrait",
  //     unit: "mm",
  //     format: [widthMm, heightMm],
  //   });

  //   const coverCanvasId =
  //     type === "premium" ? "hardCoverCanvas" : "coverCanvas";
  //   const backCoverClass =
  //     type === "premium" ? "hard-back-cover-image" : "back-cover-image";

  //   const coverCanvas = document.getElementById(coverCanvasId);
  //   const backCoverImage = document.querySelector(`.${backCoverClass}`);

  //   if (coverCanvas) {
  //     // Temporarily show hidden canvas
  //     // const originalDisplay = coverCanvas.style.display;
  //     coverCanvas.style.display = "block";

  //     const canvas = await html2canvas(coverCanvas, { scale: 2 });
  //     const imgData = canvas.toDataURL("image/jpeg", 0.9);
  //     coverPdf.addImage(imgData, "JPEG", 0, 0, widthMm, heightMm);

  //     // Re-hide the canvas
  //     // coverCanvas.style.display = originalDisplay;
  //   }

  //   if (backCoverImage) {
  //     const img = new Image();
  //     img.crossOrigin = "anonymous";
  //     await new Promise((resolve) => {
  //       img.onload = () => {
  //         const canvas = document.createElement("canvas");
  //         const ctx = canvas.getContext("2d");
  //         canvas.width = img.width;
  //         canvas.height = img.height;
  //         ctx.drawImage(img, 0, 0);
  //         const imgData = canvas.toDataURL("image/jpeg", 0.9);
  //         coverPdf.addPage([widthMm, heightMm], "portrait");
  //         coverPdf.addImage(imgData, "JPEG", 0, 0, widthMm, heightMm);
  //         resolve();
  //       };
  //       img.src = backCoverImage.src;
  //     });
  //   }

  //   return coverPdf.output("blob");
  // }

  // async function generateCoverPdf(widthMm, heightMm, type = "standard") {
  //   const spacingMm = type === "premium" ? 10 : 5;

  //   const coverCanvasId =
  //     type === "premium" ? "hardCoverCanvas" : "coverCanvas";
  //   const backCoverClass =
  //     type === "premium" ? "hard-back-cover-image" : "back-cover-image";

  //   const coverCanvas = document.getElementById(coverCanvasId);
  //   const backCoverImage = document.querySelector(`.${backCoverClass}`);

  //   if (!coverCanvas || !backCoverImage) {
  //     throw new Error("Missing cover canvas or back cover image");
  //   }

  //   coverCanvas.style.display = "block";
  //   await new Promise((r) => setTimeout(r, 100)); // ensure paint

  //   // Render front cover canvas
  //   const frontCanvas = await html2canvas(coverCanvas, { scale: 2 });
  //   const frontImg = new Image();
  //   frontImg.src = frontCanvas.toDataURL("image/jpeg");
  //   await new Promise((r) => (frontImg.onload = r));

  //   // Load back cover image
  //   const backImg = new Image();
  //   backImg.crossOrigin = "anonymous";
  //   backImg.src = backCoverImage.src;
  //   await new Promise((r) => (backImg.onload = r));

  //   // Calculate dimensions (mm to px conversion)
  //   const MM_TO_PX = 96 / 25.4; // ≈ 3.78 px per mm
  //   const spacingPx = spacingMm * MM_TO_PX;
  //   const widthPx = widthMm * MM_TO_PX;
  //   const heightPx = heightMm * MM_TO_PX;

  //   // Create combined spread canvas
  //   const spreadCanvas = document.createElement("canvas");
  //   spreadCanvas.width = Math.round(widthPx * 2 + spacingPx);
  //   spreadCanvas.height = Math.round(heightPx);
  //   const ctx = spreadCanvas.getContext("2d");

  //   // Scale and draw both images into their respective halves
  //   ctx.drawImage(backImg, 0, 0, widthPx, heightPx);
  //   ctx.drawImage(frontImg, widthPx + spacingPx, 0, widthPx, heightPx);

  //   const spreadImgData = spreadCanvas.toDataURL("image/jpeg");

  //   // Create final PDF
  //   const coverPdf = new jsPDF({
  //     orientation: "landscape",
  //     unit: "mm",
  //     format: [widthMm * 2 + spacingMm, heightMm],
  //   });

  //   coverPdf.addImage(
  //     spreadImgData,
  //     "PNG",
  //     0,
  //     0,
  //     widthMm * 2 + spacingMm,
  //     heightMm
  //   );

  //   return coverPdf.output("blob");
  // }

  //Perfectly Working Code
  // async function generateCoverPdf(type = "standard") {
  //   const spacingMm = type === "premium" ? 10 : 5;
  //   const spacingPx = spacingMm * (300 / 25.4); // ≈ 3.78 px/mm

  //   const coverCanvasId =
  //     type === "premium" ? "hardCoverCanvas" : "coverCanvas";
  //   const backCoverClass =
  //     type === "premium" ? "hard-back-cover-image" : "back-cover-image";

  //   const coverCanvas = document.getElementById(coverCanvasId);
  //   const backCoverImage = document.querySelector(`.${backCoverClass}`);

  //   if (!coverCanvas || !backCoverImage) {
  //     throw new Error("Missing cover canvas or back cover image");
  //   }

  //   await new Promise((r) => setTimeout(r, 100));

  //   const frontImg = new Image();
  //   frontImg.src = coverCanvas.toDataURL("image/jpeg", 1.0);
  //   await new Promise((r) => (frontImg.onload = r));

  //   const backImg = new Image();
  //   backImg.crossOrigin = "anonymous";
  //   backImg.src = backCoverImage.src;
  //   await new Promise((r) => (backImg.onload = r));

  //   const spineImg = new Image();
  //   spineImg.crossOrigin = "anonymous";
  //   spineImg.src =
  //     "https://cdn.shopify.com/s/files/1/0937/9302/6394/files/Spine_Stripe.png?v=1747660204";
  //   await new Promise((r) => (spineImg.onload = r));

  //   const widthPx = coverCanvas.width;
  //   const heightPx = coverCanvas.height;

  //   const spreadCanvas = document.createElement("canvas");
  //   spreadCanvas.width = Math.round(widthPx * 2 + spacingPx);
  //   spreadCanvas.height = heightPx;
  //   const ctx = spreadCanvas.getContext("2d");

  //   // Draw back cover
  //   ctx.drawImage(backImg, 0, 0, widthPx, heightPx);

  //   // Draw spine stripe
  //   ctx.drawImage(spineImg, widthPx, 0, spacingPx, heightPx);

  //   // Draw front cover
  //   ctx.drawImage(frontImg, widthPx + spacingPx, 0, widthPx, heightPx);

  //   const spreadImgData = spreadCanvas.toDataURL("image/jpeg", 1.0);

  //   const PX_TO_MM = 25.4 / 300; // High-quality print DPI
  //   const pdfWidthMm = spreadCanvas.width * PX_TO_MM;
  //   const pdfHeightMm = spreadCanvas.height * PX_TO_MM;

  //   const coverPdf = new jsPDF({
  //     orientation: "landscape",
  //     unit: "mm",
  //     format: [pdfWidthMm, pdfHeightMm],
  //   });

  //   coverPdf.addImage(spreadImgData, "JPEG", 0, 0, pdfWidthMm, pdfHeightMm);

  //   return coverPdf.output("blob");
  // }

  // async function scrollThroughAllPages() {
  //   const elements = [
  //     ...document.querySelectorAll(".intro-page"),
  //     ...document.querySelectorAll(".story-page"),
  //     ...document.querySelectorAll(".child-image-canvas"),
  //   ];

  //   for (const el of elements) {
  //     el.scrollIntoView({ behavior: "auto", block: "center" });
  //     await new Promise((r) => setTimeout(r, 500));
  //   }

  //   window.scrollTo(0, 0);
  // }

  // async function waitForImagesToLoad() {
  //   const images = [
  //     ...document.querySelectorAll("img.intro-page"),
  //     ...document.querySelectorAll(".story-page img"),
  //     document.querySelector(".back-cover-image"),
  //     document.querySelector(".hard-back-cover-image"),
  //   ].filter(Boolean);

  //   const loadPromises = images.map(
  //     (img) =>
  //       new Promise((resolve) => {
  //         if (img.complete && img.naturalHeight !== 0) resolve();
  //         else {
  //           img.onload = resolve;
  //           img.onerror = resolve;
  //         }
  //       })
  //   );

  //   await Promise.all(loadPromises);
  // }

  // function areAllCanvasesPainted(canvases) {
  //   return canvases.every((canvas) => {
  //     try {
  //       const ctx = canvas.getContext("2d");
  //       const pixels = ctx.getImageData(0, 0, 1, 1).data;
  //       return pixels.some((val) => val !== 0);
  //     } catch {
  //       return false;
  //     }
  //   });
  // }

  // async function waitForCanvasRenderingToSettle(timeout = 20000) {
  //   const canvases = [
  //     ...document.querySelectorAll("#photoCanvas"),
  //     ...document.querySelectorAll("#messageCanvas"),
  //     ...document.querySelectorAll(".child-image-canvas"),
  //   ];

  //   const start = performance.now();
  //   while (performance.now() - start < timeout) {
  //     const allPainted = areAllCanvasesPainted(canvases);
  //     if (allPainted) return true;

  //     await new Promise((r) => setTimeout(r, 500));
  //   }

  //   return false;
  // }

  // function waitForDOMStability(mutationTimeout = 1000) {
  //   return new Promise((resolve) => {
  //     let timeoutId;
  //     const observer = new MutationObserver(() => {
  //       clearTimeout(timeoutId);
  //       timeoutId = setTimeout(() => {
  //         observer.disconnect();
  //         resolve();
  //       }, mutationTimeout);
  //     });

  //     observer.observe(document.body, {
  //       childList: true,
  //       subtree: true,
  //       attributes: true,
  //     });

  //     // Initial delay in case no changes happen
  //     timeoutId = setTimeout(() => {
  //       observer.disconnect();
  //       resolve();
  //     }, mutationTimeout);
  //   });
  // }

  // function waitForLoaderToHide(
  //   selector = "#pdf-initial-loader",
  //   timeout = 15000
  // ) {
  //   return new Promise((resolve) => {
  //     const loader = document.querySelector(selector);
  //     if (!loader || getComputedStyle(loader).display === "none") {
  //       return resolve(); // Already hidden or doesn't exist
  //     }

  //     const observer = new MutationObserver(() => {
  //       if (getComputedStyle(loader).display === "none") {
  //         observer.disconnect();
  //         resolve();
  //       }
  //     });

  //     observer.observe(loader, {
  //       attributes: true,
  //       attributeFilter: ["style"],
  //     });

  //     // Fallback in case observer doesn't trigger
  //     setTimeout(() => {
  //       observer.disconnect();
  //       resolve();
  //     }, timeout);
  //   });
  // }

  // async function waitForElementsToLoadAndPaint() {
  //   await waitForImagesToLoad();
  //   await scrollThroughAllPages();
  //   await waitForDOMStability(); // DOM has stopped mutating

  //   const canvasReady = await waitForCanvasRenderingToSettle();
  //   if (!canvasReady) {
  //     console.warn("Some canvases may still be blank after waiting.");
  //   }

  //   await new Promise((resolve) =>
  //     requestAnimationFrame(() => requestAnimationFrame(resolve))
  //   );

  //   // Wait for loader to be hidden before proceeding
  //   await waitForLoaderToHide();

  //   document.body.setAttribute("data-render-complete", "true");
  // }

  // async function startAutoExportWhenReady() {
  //   while (document.body.getAttribute("data-render-complete") !== "true") {
  //     await new Promise((r) => setTimeout(r, 300));
  //   }

  //   isExporting = true;
  //   try {
  //     const result = await exportAllToPDF();
  //     exportResult = result;
  //     isExportComplete = true;
  //   } catch (err) {
  //     console.error("Auto-export failed:", err);
  //     alert(
  //       "Auto-export failed. You can try again by clicking the Continue button."
  //     );
  //   } finally {
  //     isExporting = false;
  //   }
  // }

  // waitForElementsToLoadAndPaint();
  // startAutoExportWhenReady();

  //Perfectly Working Code
  // async function exportAllToPDF() {
  //   const contentPdf = new jsPDF();
  //   contentPdf.deletePage(1); // Remove the auto-generated blank page

  //   const photoCanvas = document.getElementById("photoCanvas");
  //   const messageCanvas = document.getElementById("messageCanvas");

  //   const frontBlankImage = document.querySelector(".front-blank-page-image");
  //   const backBlankImage = document.querySelector(".back-blank-page-image");

  //   // Add Front Blank Page FIRST
  //   if (frontBlankImage) {
  //     await addImageToPDF(contentPdf, frontBlankImage);
  //   }

  //   // Add Content Pages
  //   if (photoCanvas) await addCanvasToPDF(contentPdf, photoCanvas);
  //   if (messageCanvas) await addCanvasToPDF(contentPdf, messageCanvas);

  //   const introImages = document.querySelectorAll(".intro-page");
  //   for (const img of introImages) await addImageToPDF(contentPdf, img);

  //   const storyPages = document.querySelectorAll(".story-page");
  //   for (const page of storyPages) {
  //     const canvas = page.querySelector(".child-image-canvas");
  //     if (canvas) {
  //       await addCanvasToPDF(contentPdf, canvas);
  //     } else {
  //       const img = page.querySelector("img");
  //       if (img) await addImageToPDF(contentPdf, img);
  //     }
  //   }

  //   // Add Back Blank Page LAST
  //   if (backBlankImage) {
  //     await addImageToPDF(contentPdf, backBlankImage);
  //   }

  //   const contentPdfBlob = contentPdf.output("blob");

  //   try {
  //     const contentUrl = await uploadToFirebaseStorage(contentPdfBlob);

  //     const premiumCoverBlob = await generateCoverPdf("premium");
  //     const standardCoverBlob = await generateCoverPdf("standard");

  //     const premiumCoverUrl = await uploadToFirebaseStorage(premiumCoverBlob);
  //     const standardCoverUrl = await uploadToFirebaseStorage(standardCoverBlob);

  //     localStorage.setItem("firebaseContentPdfLink", contentUrl);
  //     localStorage.setItem("firebasePremiumCoverPdfLink", premiumCoverUrl);
  //     localStorage.setItem("firebaseStandardCoverPdfLink", standardCoverUrl);

  //     navigator.clipboard.writeText(contentUrl);

  //     return {
  //       contentUrl,
  //       premiumCoverUrl,
  //       standardCoverUrl,
  //     };
  //   } catch (err) {
  //     console.error("Upload failed", err);
  //     alert("Upload failed. Check console for details.");
  //   }
  // }

  // async function exportAllToPDF() {
  //   const pdf = new jsPDF();

  //   const coverCanvas = document.getElementById("coverCanvas");
  //   const photoCanvas = document.getElementById("photoCanvas");
  //   const messageCanvas = document.getElementById("messageCanvas");

  //   if (coverCanvas) await addCanvasToPDF(pdf, coverCanvas, true);
  //   if (photoCanvas) await addCanvasToPDF(pdf, photoCanvas);
  //   if (messageCanvas) await addCanvasToPDF(pdf, messageCanvas);

  //   const introImages = document.querySelectorAll(".intro-page");
  //   for (const img of introImages) await addImageToPDF(pdf, img);

  //   const storyPages = document.querySelectorAll(".story-page");
  //   for (const page of storyPages) {
  //     const canvas = page.querySelector(".child-image-canvas");
  //     if (canvas) await addCanvasToPDF(pdf, canvas);
  //     else {
  //       const img = page.querySelector("img");
  //       if (img) await addImageToPDF(pdf, img);
  //     }
  //   }

  //   const backCoverImage = document.querySelector(".back-cover-image");
  //   if (backCoverImage) await addImageToPDF(pdf, backCoverImage);

  //   // Export as blob and upload
  //   const pdfBlob = pdf.output("blob");

  //   try {
  //     // // Sign in and get access token here!
  //     // const accessToken = await getAccessTokenFromRefreshToken();

  //     const firebaseUrl = await uploadToFirebaseStorage(pdfBlob);

  //     console.log("PDF uploaded successfully to Firebase:", firebaseUrl);
  //     navigator.clipboard.writeText(firebaseUrl);
  //     return firebaseUrl;

  //     // Now you can send this driveUrl to your printer partner through your API
  //   } catch (err) {
  //     console.error("Upload failed", err);
  //     alert("Upload failed. Check console for details.");
  //   }
  // }

  //Perfectly Working Fine
  // const exportBtn = document.getElementById("continue-to-format-btn");
  // if (exportBtn) {
  //   exportBtn.addEventListener("click", async (e) => {
  //     e.preventDefault();

  //     const loader = document.getElementById("pdf-loader");
  //     loader && (loader.style.display = "flex");
  //     document.body.style.overflow = "hidden";

  //     try {
  //       if (isExportComplete) {
  //         // Already exported, redirect immediately
  //         window.location.href = "/pages/format";
  //       } else {
  //         // Wait for ongoing export
  //         while (isExporting && !isExportComplete) {
  //           await new Promise((r) => setTimeout(r, 300));
  //         }
  //         window.location.href = "/pages/format";
  //       }
  //     } catch (error) {
  //       console.error("Error waiting for export:", error);
  //       alert("Something went wrong. Please try again.");
  //     } finally {
  //       loader && (loader.style.display = "none");
  //       document.body.style.overflow = "";
  //     }
  //   });
  // }
  const exportBtn = document.getElementById("continue-to-format-btn");
  if (exportBtn) {
    exportBtn.addEventListener("click", (e) => {
      e.preventDefault();
      window.location.href = "/pages/format";
    });
  }
});
